import React from 'react';
import { useTranslation } from 'react-i18next';

export const RedemptionPolicy: React.FC = () => {
    const { t } = useTranslation();

    const sections = t('redemptionPolicy.sections', { returnObjects: true }) as Array<{ title: string; content: string }>;

    return (
        <div className="min-h-screen relative overflow-hidden">
            {/* Animated Background Elements */}
            <div className="fixed inset-0 pointer-events-none">
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
            </div>

            {/* Hero Section */}
            <section className="relative min-h-[40vh] flex items-center justify-center overflow-hidden">
                <div className="hero-background absolute inset-0">
                    <div
                        className="absolute inset-0 opacity-30"
                        style={{
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='grid' width='100' height='100' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 100 0 L 0 0 0 100' fill='none' stroke='rgba(212, 175, 55, 0.1)' stroke-width='1'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23grid)' /%3E%3C/svg%3E")`,
                        }}
                    />
                </div>

                <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto pt-20">
                    <div className="hero-badge inline-block px-4 py-2 bg-gold/10 rounded-full mb-6">
                        <span className="text-gold font-semibold text-sm uppercase tracking-wider">Policy</span>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent">
                        {t('redemptionPolicy.title')}
                    </h1>
                </div>
            </section>

            {/* Content Section */}
            <section className="section relative -mt-10">
                <div className="container max-w-4xl mx-auto">
                    <div className="bg-surface/80 backdrop-blur-md rounded-2xl border border-gold/20 p-8 md:p-12 shadow-xl shadow-gold/5">
                        <p className="text-lg text-gray-300 mb-10 leading-relaxed text-center">
                            {t('redemptionPolicy.description')}
                        </p>

                        <div className="space-y-8 mb-16">
                            {sections.map((section, index) => (
                                <div key={index} className="modern-card group">
                                    <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-3">
                                        <span className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center text-gold text-sm group-hover:bg-gold group-hover:text-black transition-colors">
                                            {index + 1}
                                        </span>
                                        {section.title.replace(/^\d+\.\s*/, '')}
                                    </h3>
                                    <div className="text-gray-400 pl-11 whitespace-pre-line leading-relaxed">
                                        {section.content}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Transparency Section */}
                        <div className="mb-10 text-center">
                            <div className="w-16 h-16 bg-gradient-to-br from-gold/20 to-gold/5 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                <i className="fas fa-search-dollar text-3xl text-gold"></i>
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-6">
                                {t('redemptionPolicy.transparencyTitle')}
                            </h3>
                            <p className="text-gray-400 max-w-2xl mx-auto whitespace-pre-line leading-relaxed">
                                {t('redemptionPolicy.transparencyContent')}
                            </p>
                        </div>

                        {/* Support Footer */}
                        <div className="mt-12 pt-8 border-t border-gold/20 text-center">
                            <div className="inline-flex items-center gap-3 px-6 py-3 bg-gold/5 rounded-full text-gold-light border border-gold/10">
                                <i className="fas fa-headset"></i>
                                <span>{t('redemptionPolicy.footer')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
